export default __webpack_public_path__ + "static/media/slstmcode.7c9fbe99.png";